import { render, staticRenderFns } from "./select-delivery-type.vue?vue&type=template&id=7a2d8620&scoped=true&"
import script from "./select-delivery-type.vue?vue&type=script&lang=js&"
export * from "./select-delivery-type.vue?vue&type=script&lang=js&"
import style0 from "./select-delivery-type.vue?vue&type=style&index=0&id=7a2d8620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d8620",
  null
  
)

export default component.exports